import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const DownloadMetaJson = createAsyncThunk(
    "downloadMetaJson", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPost(urls?.downloadMetaJson, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const DownloadMetaJsonSlice = createSlice({
    name: "downloadMetaJson",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        downloadMetaJsonReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [DownloadMetaJson.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [DownloadMetaJson.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [DownloadMetaJson.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { downloadMetaJsonReset } = DownloadMetaJsonSlice.actions;